<p-toast position="bottom-left" [key]="toastGMessageKey" styleClass="!border-none !bg-transparent">
  <ng-template let-message #headless let-closeFn="closeFn">
    <section class="flex gap-3 items-center p-4 w-full bg-black text-black rounded-2xl">
      @if(message.severity === 'success'){
      <i class="pi pi-check-circle text-green-600 text-md"></i>
      }@else if(message.severity === 'error') {
      <i class="pi pi-times-circle text-red-600 text-md"></i>
      }@else if(message.severity === 'warn') {
      <i class="pi pi-exclamation-circle text-orange-300 text-md"></i>
      }@else if(message.severity === 'info') {
      <i class="pi pi-info-circle text-blue-500 text-md"></i>
      } @else{
      <i class="pi pi-check-circle text-green-600 text-md"></i>
      }
      <span class="font-bold text-base text-white">{{ message.detail }}</span>
    </section>
  </ng-template>
</p-toast>
